import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-200 my-auto">
      <div className="w-full max-w-screen-xl mx-auto p-3">
        <div className="text-center">
          <p className="font-medium">
            &copy; 2026 Air Brick Infra || All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
